import React from 'react';
import type { Hero } from 'types/hero';

import Image from 'next/image';
import { Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';

const HeroAbout: React.FC<Hero> = ({ subTitle, title, description }) => {
  return (
    <Wrap className="hero-about" tagName="header" spacer={true}>
      <div className="text-center grid gap-y-10 md:max-w-5xl justify-self-center justify-items-center">
        <HeadingBody
          {...{
            level: '2',
            tagName: 'h1',
            title: title,
            className:
              '!text-3xl md:!text-4xl lg:!text-5xl xl:!text-7xl text-center text-balance',
          }}
        />
        <Paragraph className="text-lg md:max-w-xl">{subTitle}</Paragraph>
        <Image
          src="/about-hero-img-desktop.jpg"
          alt=""
          className="mt-10 hidden md:block"
          loading="lazy"
          width={956}
          height={243}
        />
        <Image
          src="/about-hero-img-mobile.jpg"
          alt=""
          className="md:hidden"
          loading="lazy"
          width={956}
          height={243}
        />
        <WysiwygContent
          content={description}
          className="md:max-w-xl"
          largerParagraph={true}
        />
      </div>
    </Wrap>
  );
};

export default HeroAbout;
